// mds-dojo — dijit/layout/utils — FAITHFUL port of references/dijit/layout/utils.js.
// AMD define([...]) → ESM; only the module's final `return utils` becomes
// `export default` (the inner capitalize()/size() returns are left intact).
// domGeometry's box-extent/setMarginBox helpers come from the local ./_geometry
// (the canonical dojo/dom-geometry only ships getMarginBox).
import array from '../../dojo/_base/array';
import domClass from '../../dojo/dom-class';
import domGeometry from '../../dojo/dom-geometry';
import domStyle from '../../dojo/dom-style';
import lang from '../../dojo/_base/lang';

function capitalize(word: string) {
  return word.substring(0, 1).toUpperCase() + word.substring(1);
}

function size(widget: any, dim: any) {
  // size the child
  var newSize = widget.resize ? widget.resize(dim) : domGeometry.setMarginBox(widget.domNode, dim);

  // record child's size
  if (newSize) {
    // if the child returned its new size then use that
    lang.mixin(widget, newSize);
  } else {
    // otherwise, call getMarginBox(), but favor our own numbers when we have them.
    lang.mixin(widget, domGeometry.getMarginBox(widget.domNode));
    lang.mixin(widget, dim);
  }
}

var utils = {
  // summary:
  //		Utility functions for doing layout

  marginBox2contentBox: function (node: any, mb: any) {
    // Given the margin-box size of a node, return its content box size.
    var cs = domStyle.getComputedStyle(node);
    var me = domGeometry.getMarginExtents(node, cs);
    var pb = domGeometry.getPadBorderExtents(node, cs);
    return {
      l: domStyle.toPixelValue(node, cs.paddingLeft),
      t: domStyle.toPixelValue(node, cs.paddingTop),
      w: mb.w - (me.w + pb.w),
      h: mb.h - (me.h + pb.h)
    };
  },

  layoutChildren: function (container: any, dim: any, children: any,
    changedRegionId?: any, changedRegionSize?: any) {
    // Layout a bunch of child dom nodes within a parent dom node

    // copy dim because we are going to modify it
    dim = lang.mixin({}, dim);

    domClass.add(container, 'dijitLayoutContainer');

    // Move "client" elements to the end of the array for layout.
    children = array.filter(children, function (item: any) { return item.region != 'center' && item.layoutAlign != 'client'; })
      .concat(array.filter(children, function (item: any) { return item.region == 'center' || item.layoutAlign == 'client'; }));

    // set positions/sizes
    array.forEach(children, function (child: any) {
      var elm = child.domNode,
        pos = (child.region || child.layoutAlign);
      if (!pos) {
        throw new Error('No region setting for ' + child.id);
      }

      // set elem to upper left corner of unused space; may move it later
      var elmStyle = elm.style;
      elmStyle.left = dim.l + 'px';
      elmStyle.top = dim.t + 'px';
      elmStyle.position = 'absolute';

      domClass.add(elm, 'dijitAlign' + capitalize(pos));

      // Size adjustments to make to this child widget
      var sizeSetting: any = {};

      // Check for optional size adjustment due to splitter drag
      if (changedRegionId && changedRegionId == child.id) {
        sizeSetting[child.region == 'top' || child.region == 'bottom' ? 'h' : 'w'] = changedRegionSize;
      }

      if (pos == 'leading') {
        pos = child.isLeftToRight() ? 'left' : 'right';
      }
      if (pos == 'trailing') {
        pos = child.isLeftToRight() ? 'right' : 'left';
      }

      // set size && adjust record of remaining space.
      if (pos == 'top' || pos == 'bottom') {
        sizeSetting.w = dim.w;
        size(child, sizeSetting);
        dim.h -= child.h;
        if (pos == 'top') {
          dim.t += child.h;
        } else {
          elmStyle.top = dim.t + dim.h + 'px';
        }
      } else if (pos == 'left' || pos == 'right') {
        sizeSetting.h = dim.h;
        size(child, sizeSetting);
        dim.w -= child.w;
        if (pos == 'left') {
          dim.l += child.w;
        } else {
          elmStyle.left = dim.l + dim.w + 'px';
        }
      } else if (pos == 'client' || pos == 'center') {
        size(child, dim);
      }
    });
  }
};

lang.setObject('dijit.layout.utils', utils); // remove for 2.0

export default utils;
